<template>
  <div id="app">
      <ion-app v-if="mobileValidation" >
        <ion-vue-router id="main-content" />
        <ion-modal-controller></ion-modal-controller>
      </ion-app>
      <div class="desktop-view" v-else>
        <ion-vue-router id="main-content" />
      </div>
  </div>
</template>
<script>
// import Push from "push.js"
// import firebase from 'firebase/app'
import axios from 'axios';
import firebaseA from './config'; 
import {func} from './func.js'
// import 'firebase/messaging';

let messaging  = null;
try {
  messaging  = firebaseA.messaging;
} catch (error) {
  messaging  = null;
  console.log("No es posible incializar el la mensajeria.") 
}

// messaging.usePublicVapidKey("BHviwvR2qF_lMrZP5MdUE56J9Z6nGowNYKnRxa0Y5-0Hk94vKi_Ju9MsIfu4kPlZgcrd0ANpbVJPTKsOPK0NLcE");

// messaging.usePublicVapidKey("BHviwvR2qF_lMrZP5MdUE56J9Z6nGowNYKnRxa0Y5-0Hk94vKi_Ju9MsIfu4kPlZgcrd0ANpbVJPTKsOPK0NLcE");
// messaging.onMessage((payload) => {
//   console.log('Message received. ', payload);
// });

export default {
  data() {
    return {
      mobileValidation:true,
      StrToken:{
        txt:"",
        otherTxt:{}
      },
      info: null
    };
  },
  mounted (){
    // console.log("Created methoed  => ",messaging);
    if( messaging  != null ){ this.notificationsPermisionRequest(); }
  },
  created() {
    this.mobileValidation = func.isMobile();
  },
  methods: {
    getMessagingToken () {
        messaging.getToken().then(async (token) => {
            if (token) {
                    const currentMessageToken = window.localStorage.getItem('messagingToken')
                    console.log('token will be updated', currentMessageToken != token ,"TOKEN:", token);

                    if(currentMessageToken != token){
                        await this.saveToken(token)
                    }
                } else {
                    console.log('No Instance ID token available. Request permission to generate one.');
                    this.notificationsPermisionRequest();
                }
        }).catch(function(err) {
            console.log('An error occurred while retrieving token. ', err);
        });
    },
    notificationsPermisionRequest () {
      // alert("solicitando permisos");
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
          // TODO(developer): Retrieve an Instance ID token for use with FCM.
          // Push.create('Hello World!');
          // ...
        } else {
          console.log('Unable to get permission to notify.');
        }
      });
        messaging.requestPermission()
        .then(() => {
            this.getMessagingToken();
        })
        .catch((err) => {
            console.log('Unable to get permission to notify.', err);
        }); 
    },
    listenTokenRefresh() {
        const currentMessageToken = window.localStorage.getItem('messagingToken')
        
        if( currentMessageToken == null){
          console.log('currentMessageToken ES NULO; asignando ');
            messaging.onTokenRefresh(function() {
                messaging.getToken().then(function(token) {
                    this.saveToken(token);
                }).catch(function(err) {
                    console.log('Unable to retrieve refreshed token ', err);
                });
            });
        }
    },
    showAlert(msg,title) {
      return this.$ionic.alertController
        .create({
          header: title,
          message: msg,
          buttons: ["Aceptar"]
        })
        .then(a => a.present());
    },
    saveToken(token) {
        console.log('tokens', token)
        axios.post(`https://us-central1-mi-test-b974c.cloudfunctions.net/GeneralSubscription`,{ token })
        .then(response => {
            window.localStorage.setItem('messagingToken',token)
            console.log(response)
            // axios.post(`https://us-central1-mi-test-b974c.cloudfunctions.net/SendNotification`,{ token, "solicitud": "FEekafeukfue32rfe"  })
            // .then( r => console.log("second resp: ", r))
            // .catch( error =>  r => console.log("Second Err", error) )
        }).catch((err) => {
            console.log(err)
        })
    },
  },  
  
}
</script>